import * as Types from '../graphql.generated';

import { Listing_FragmentFragment } from './listing.fragment.generated';
import { Location_FragmentFragment } from './location.fragment.generated';
import { gql } from '@apollo/client';
import { Listing_FragmentFragmentDoc } from './listing.fragment.generated';
import { Location_FragmentFragmentDoc } from './location.fragment.generated';
export type Listing_Map_FragmentFragment = { __typename?: 'Listing' } & {
    location?: Types.Maybe<
        { __typename?: 'ListingLocation' } & Location_FragmentFragment
    >;
} & Listing_FragmentFragment;

export const Listing_Map_FragmentFragmentDoc = gql`
    fragment LISTING_MAP_FRAGMENT on Listing {
        ...LISTING_FRAGMENT
        location {
            ...LOCATION_FRAGMENT
        }
    }
    ${Listing_FragmentFragmentDoc}
    ${Location_FragmentFragmentDoc}
`;
